import { apiSlice } from "../api/apiSlice";

export const branchAcReportApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    branchAcReportDataFetch: builder.mutation({
      query: (data) => ({
        url: "/apiV2/ac/branch-ac-report",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  //   useGetAcPeripheralListQuery,
  //   useCreateAcPeripheralMutation,
  useBranchAcReportDataFetchMutation,
} = branchAcReportApi;
